<template>
  <div class="home-box">
    <div class="title">
      <span>{{ title }}</span>
    </div>
    <div class="box-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['type', 'title']
}
</script>

<style scoped>
.home-box {
  width: 100%;
  height: 266px;
}

.title {
  height: 40px;
  /* background-color: #0d6ca9; */
  background-color: #047db0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 5px ;
  border-top-right-radius: 5px;
}

.title span {
  color: white;
  text-transform: uppercase;
}

.box-body {
  width: 100%;
  height: 226px;
  border: 1px solid #0d6ca9;
  border-bottom: 5px solid #0d6ca9;
}

@media (max-width: 950px) {
  .home-box {
    width: 250px;
    height: 266px;
  }
}

@media (max-width: 650px) {
  .home-box {
    width: 210px;
    height: 266px;
  }
}
</style>
